import { performGetRequest } from '@atlassian/jira-fetch/src/index.tsx';
import { getCmdbTasksUrl } from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/tasks.tsx';
import type { WorkspaceId } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';
import type { Task } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/task.tsx';

export const getAllTasks = (workspaceId: WorkspaceId): Promise<Task[]> => {
	return performGetRequest(getCmdbTasksUrl(workspaceId));
};
